import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './general-journey.css';
import { Table, Button } from "reactstrap";
import TollTipChildren from "../../../components/tolltip-children/TollTipChildren";



class GeneralJourney extends React.Component {
    columns = [
        "Matrícula",
        "Nome / Motorista",
        "Horas Negativas",
        "Horas Positivas",
        "Saldo de Horas",
    ]

    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            table: [],
            alert: { msg: 'Selecione data de inicio e fim e filtre.', type: '' },
            loading: false,
            filter: {
                startPeriod: "",
                endPeriod: "",
                idDrivers: [],
            }
        }
    }




    componentDidMount() {
        // this.getJourneys(this.state.filter)
    }

    getJourneys = data => {
        this.setState({ loading: true, table: [], alert: { msg: '', type: '' } });
        axios({
            method: !data ? 'get' : 'post',
            url: `${url}/v1/telemetria/admin/journey/list/general/${this.props.token}`,
            data
        }).then(d => {
            var msg = !d.data.data.length ? 'Não encontramos dados para os filtros selecionados.' : ''
            console.log(d)
            this.setState({
                loading: false,
                table: d.data.data,
                // filter: d.data.reportFilter,
                alert: { msg, type: '' }
            })
        }).catch(e => {
            console.log(e.response)
            var errorMsg = e.response.data.errorMessage
            this.setState({ loading: false })
            errorMsg.forEach(d => {
                if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
            })
        })
    };

    exportJourney = body => {
        this.setState({ loading: true });
        console.log(body)
        axios
            .request({
                url: `${url}/v1/telemetria/admin/journey/export/byGeneral/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    responseType: "blob"
                }
            })
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data.data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `general_journey_${body.startPeriod}_${body.endPeriod}.xlsx`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
                console.log(data)
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    downloadRep = body => {
        this.setState({ loading: true });

        axios
            .request({
                url: `${url}/v1/telemetria/admin/journey/rep/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    responseType: "blob"
                }
            })
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data.data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `rep_${body.startPeriod}_${body.endPeriod}.txt`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
                // console.log(data.headers)
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };


    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()}
                        value={this.state.filter.startPeriod} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        max={getFDate()}
                        value={this.state.filter.endPeriod}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getJourneys(this.state.filter)}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.length ? (
                    <div style={{ marginRight: '5px' }}>

                        <div style={{display: 'flex'}}>
                            <div className='export-button-container'>
                                <TollTipChildren text='Exportar Para Excel' id='export-to-excel'>
                                    <Button type="button" className='export-button' id='export-to-excel' onClick={() => this.exportJourney(this.state.filter)} />
                                </TollTipChildren>
                            </div>
                            <div className='export-button-container' style={{ marginLeft: '-40px' }}>
                                <TollTipChildren text='Download Arquivo REP' id='download-rep-file'>
                                    <Button type="button" className='export-button export-button-orange' id='download-rep-file' onClick={() => this.downloadRep(this.state.filter)} />
                                </TollTipChildren>
                            </div>

                        </div>

                        <Table responsive className="table-change-color standard-table">
                            <thead>
                                <tr>
                                    {this.columns.map((d, i) => {
                                        return (
                                            <th key={i} style={{minWidth: '200px', width: '30%'}}>{d}</th>
                                        )
                                    })}
                                </tr>
                            </thead>
                            <tbody>

                                {this.state.table.map((d, i) => {
                                    return (
                                        <tr key={i} className='tr-table-pendencie tr-table-change-color'>
                                            <td className='td-table-journey-control' style={{minWidth: '200px', width: '30%'}}>{d.workerId}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '200px', width: '30%'}}>{d.driverName}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '200px', width: '30%'}}>{d.negativeTime}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '200px', width: '30%'}}>{d.positiveTime}</td>
                                            <td className='td-table-journey-control' style={{minWidth: '200px', width: '30%'}}>{d.balanceTime}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default GeneralJourney